import { NMUI4DContext } from 'app/common/context/NMUI4DContext';
import React, { useContext, useEffect } from 'react';

export const ConsoleLoggingOverrider = () => {
    const context = useContext(NMUI4DContext);

    useEffect(() => {
        // NOTE(bjarne): Overriding the log functions so we can capture all iFlow logs.
        const originalLog = window.console.log;
        const originalWarn = window.console.warn;
        const originalError = window.console.error;
        window.console.log = (message?: unknown, ...optionalParams: unknown[]) => {
            originalLog(message, ...optionalParams);
            context.logger.info(message, ...optionalParams);
        };
        window.console.warn = (message?: unknown, ...optionalParams: unknown[]) => {
            originalWarn(message, ...optionalParams);
            context.logger.warn(message, ...optionalParams);
        };
        window.console.error = (message?: unknown, ...optionalParams: unknown[]) => {
            originalError(message, ...optionalParams);
            context.logger.error(message, ...optionalParams);
        };

        return () => {
            window.console.log = originalLog;
            window.console.warn = originalWarn;
            window.console.error = originalError;
        };
    }, []);

    return <></>;
};
